"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * @param {{
 *     startHour: number;
 *     startMinute: number;
 *     endHour: number;
 *     endMinute: number;
 *     timeZone: string;
 * }} props
 */
function TimeBlockingMessage(_ref) {
  var startHour = _ref.startHour,
    startMinute = _ref.startMinute,
    endHour = _ref.endHour,
    endMinute = _ref.endMinute,
    timeZone = _ref.timeZone;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: '26px',
      fontWeight: 'bold'
    }
  }, ' ', /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: '28px',
      fontWeight: 'bold'
    }
  }, "\u26A0\uFE0F"), " Aten\xE7\xE3o: Pol\xEDtica de Seguran\xE7a de Hor\xE1rio"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left',
      padding: '8px'
    }
  }, "O acesso \xE0 sua conta est\xE1 com restri\xE7\xE3o de ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, "hor\xE1rio ativado"), ".", /*#__PURE__*/_react["default"].createElement("br", null), "Isso ocorre porque a empresa associada \xE0 sua conta restringe os acessos fora do intervalo de", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, startHour.toString().padStart(2, '0'), ":", startMinute.toString().padStart(2, '0'), " \xE0s ", endHour, ":", endMinute), ' ', "(Hor\xE1rio de ", timeZone, ").", /*#__PURE__*/_react["default"].createElement("br", null), "Esta medida \xE9 crucial para garantir a seguran\xE7a da sua conta.", /*#__PURE__*/_react["default"].createElement("br", null), "Por favor, tente novamente durante o hor\xE1rio permitido ou entre em contato com o nosso suporte para obter assist\xEAncia."));
}
var _default = TimeBlockingMessage;
exports["default"] = _default;